import { h } from 'preact'
import { isNequiThirdPartyCheckout } from '../../utils/helpers'
import { THIRD_PARTY_CHECKOUTS } from '../../utils/types'
import i18next from '../../i18n/i18n'
import loaderStatic from '../../assets/spinner/static.svg'
import loaderRing from '../../assets/spinner/ring.svg'
import PropTypes from 'prop-types';

import style from './LoaderSpinner.sass'

export default function LoaderSpinner({ thirdPartyCheckout, title, description, showText = true }) {
  const isNequi = isNequiThirdPartyCheckout(thirdPartyCheckout)

  if (isNequi) {
    return (
      <div className={`${style.loaderSpinner} ${style["loaderSpinner-nequi"]}`} />
    )
  }

  return (
    <div className={style.loaderContainer}>
      <div className={style.loaderWrapper}>
        {thirdPartyCheckout !== THIRD_PARTY_CHECKOUTS.DEFAULT &&
          <div>
            <img className={style.loaderStatic} src={loaderStatic} alt="logo" />
            <img className={style.loaderRing} src={loaderRing} alt="loading" />
          </div>}
      </div>
      {showText && (
        <div className={style.loaderTextBlock}>
          <span className={style.loaderTitle}>
            {title || i18next.t("spinner.title")}
          </span>
          <span className={style.loaderDescription}>
            {description || i18next.t("spinner.description")}
          </span>
        </div>
      )}
    </div>
  )
}

LoaderSpinner.propTypes = {
  thirdPartyCheckout: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  showText: PropTypes.bool,
};
